<!-- <app-template-select
  [disabled]="disabled"
  [value]="value"
  [control]="control"
  [required]="required"
  [disabled]="disabled"
  [options]="options"
  [multiple]="multiple"
  [label]="label"
/> -->
<app-template-search
  (onblur)="onblur.emit()"
  [disabled]="disabled"
  [value]="value"
  [control]="control"
  [required]="required"
  [disabled]="disabled"
  [options]="options"
  [multiple]="multiple"
  [label]="label"
/>
